import { Component, OnInit, TemplateRef } from '@angular/core';
import { Observable } from 'rxjs';
import { ThemeService } from '@wind-log_library/fe-component-library';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-colorcode-legend',
    templateUrl: './colorcode-legend.component.html',
    styleUrls: ['./colorcode-legend.component.scss'],
    standalone: false
})
export class ColorcodeLegendComponent implements OnInit {
  public active = 0;
  public buttons = ['COLORSCODE.WINDPARK_BUTTON', 'COLORSCODE.TURBINE_BUTTON'];
  public theme$: Observable<string>;
  public modalRef: BsModalRef;

  constructor(private themeService: ThemeService, private modalService: BsModalService) {}

  ngOnInit() {
    this.theme$ = this.themeService.getTheme();
  }

  public changeActiveTab(event) {
    this.active = event;
  }

  public openColorLegendPopup(template: TemplateRef<any>): void {
    this.modalRef = this.modalService.show(template, {
      backdrop: true,
      keyboard: false,
      animated: false, 
      class: `modal-lg modal-dialog-centered ${this.themeService.getTheme().value}`,
    });
  }

  public closeModal(): void {
    this.modalRef.hide();
  }
}
